<p-dialog
  [visible]="showLoaderDialog"
  [modal]="true"
  [closable]="false"
  [resizable]="false"
  [draggable]="false"
  [showHeader]="false"
>
  <div *ngIf="loaderConfig" class="dialog-content">
    <img
      class="loader-image"
      [src]="loaderConfig.image"
      [alt]="loaderConfig.alt"
    />
    <div class="dialog-text">
      <div class="header-text">{{ loaderConfig.header }}</div>
      <div class="value-text">{{ loaderConfig.message }}</div>
    </div>
  </div>
</p-dialog>
